/**
 * Human-readable byte size — "834 B", "412.0 KB", "1.5 MB".
 *
 * Returns "-" for undefined / zero so callers can render it directly in a table cell.
 */
export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
